// extracted by mini-css-extract-plugin
export default {"root":"y4D76WrG6tfhiKnKGLsK","items":"rzIfXdSIllKRVUP3CB0W","placeHolderShimmer":"f7PuSD7UPJhWICgxTASd"};